module.exports = __webpack_public_path__ + "img/gd.a9672f78.svg";